import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'


import Home from '../components/Home'
import MemberCenter from '../components/MemberCenter.vue'
import PaymentCenter from '../components/PaymentCenter.vue'
import PaymentDetail from '../components/PaymentDetail.vue'
import Fix from '../components/Fix.vue'
import FixMy from '../components/FixMy.vue'
import FixDetail from '../components/FixDetail.vue'
import Complain from '../components/Complain.vue'
import ComplainMy from '../components/ComplainMy.vue'
import ComplainDetail from '../components/ComplainDetail.vue'
import LetPass from '../components/LetPass.vue'
import LetPassMy from '../components/LetPassMy.vue'
import LetPassDetail from '../components/LetPassDetail.vue'
import HelpCenter from '../components/HelpCenter.vue'
import HelpDetail from '../components/HelpDetail.vue'
import Login from '../components/Login.vue'
import WxLoginState from '../components/weixin/Login.vue'
import SIdentify  from '../components/page/identify.vue'
import MemberCheck  from '../components/MemberCheck.vue'
import HouseMy  from '../components/HouseMy.vue'
import HouseAdd  from '../components/HouseAdd.vue'

Vue.use(Router)
Vue.use(SIdentify)

export default new Router({
  mode: 'history',
  //base: '/dist/',
  routes: [	
     {
     	name:'雅文物业',
	    path: '/',
	    component: Home
	  },
	  {
	  	name:'用户中心',
	    path: '/MemberCenter',
	    component: MemberCenter
	  },
	  {
	  	name:'支付中心',
	    path: '/PaymentCenter',
	    component: PaymentCenter
	  },
	  {
	  	name:'支付详情',
	    path: '/PaymentDetail',
	    component: PaymentDetail
	  },
	  {
	  	name:'我要报修',
	    path: '/Fix',
	    component: Fix
	  },
	  {
	  	name:'我的报修',
	    path: '/FixMy',
	    component: FixMy
	  },
	  {
	  	name:'报修详情',
	    path: '/FixDetail',
	    component: FixDetail
	  },
	  {
	  	name:'我要投诉',
	    path: '/Complain',
	    component: Complain
	  },
	  {
	  	name:'我的投诉',
	    path: '/ComplainMy',
	    component: ComplainMy
	  },
	  {
	  	name:'投诉详情',
	    path: '/ComplainDetail',
	    component: ComplainDetail
	  },
	  {
	  	name:'我要放行',
	    path: '/LetPass',
	    component: LetPass
	  },
	  {
	  	name:'我的放行',
	    path: '/LetPassMy',
	    component: LetPassMy
	  },
	  {
	  	name:'放行详情',
	    path: '/LetPassDetail',
	    component: LetPassDetail
	  },
	  {
	  	name:'常见问题',
	    path: '/HelpCenter',
	    component: HelpCenter
	  },
	  {
	  	name:'问题详情',
	    path: '/HelpDetail',
	    component: HelpDetail
	  },
	  {
	  	name:'登录',
	    path: '/Login',
	    component: Login
	  },
	  {
	  	name:'微信登录提示',
	    path: '/WxLoginState',
	    component: WxLoginState
	  },
	  {
	  	name:'',
	    path: '/SIdentify ',
	    component: SIdentify
	  },
	  {
	  	name:'登录验证',
	    path: '/MemberCheck',
	    component: MemberCheck
	  },
	  {
	  	name:'房间选择/切换',
	    path: '/HouseMy',
	    component: HouseMy
	  },
	  /*{
	    path: '/HouseAdd',
	    component: HouseAdd
	  },*/
	  
	  
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js